import * as React from "react";
import { Edit, required, SimpleForm, TextInput, useRecordContext } from "react-admin";
import { MonthDayInput } from "../../components/monthDayInput/MonthDayInput";

export const TimePeriodEdit = () => {
  const validateTimePeriodEdit = (values) => {
    const errors: any = {};

    const start = new Date(values.start);
    const end = new Date(values.end);
    const startMD = start.getMonth() * 100 + start.getDate();
    const endMD = end.getMonth() * 100 + end.getDate();

    if (startMD === endMD) {
      errors.end = `Start och slut kan inte vara samma dag`;
    }

    return errors;
  };

  const record = useRecordContext();

  return (
    <Edit id={record?.id}>
      <SimpleForm
        validate={validateTimePeriodEdit}
      >
        <TextInput source="name" validate={[required()]} fullWidth />
        <MonthDayInput
          source="start"
          label="Start (månad & dag)"
          validate={[required()]}
        />
        <MonthDayInput
          source="end"
          label="Slut (månad & dag)"
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
};
